export const swwAffiliateArrowLeft = (
  <svg
    width="9"
    height="16"
    viewBox="0 0 9 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.56738 0.219852C7.84879 -0.0634597 8.31008 -0.0737105 8.60547 0.193485L8.65918 0.247196C8.91057 0.526835 8.90571 0.954339 8.63379 1.22864L2.06641 7.84974L8.63379 14.4708L8.68457 14.5275C8.90531 14.8013 8.89376 15.1912 8.65918 15.4523L8.60547 15.506C8.31004 15.7733 7.84882 15.7631 7.56738 15.4796L0.245117 8.09583L0 7.84974L0.245117 7.60364L7.56738 0.219852ZM8.4834 15.0568C8.47249 15.1036 8.45261 15.1489 8.42285 15.1896C8.43767 15.1693 8.4508 15.1483 8.46094 15.1261C8.47121 15.1037 8.47792 15.0803 8.4834 15.0568ZM8.38574 0.982548L8.42871 0.93079L8.42969 0.92786C8.4168 0.946863 8.40262 0.965507 8.38574 0.982548Z"
      fill="#F28741"
    />
  </svg>
);

export const swwAffiliateArrowRight = (
  <svg
    width="10"
    height="18"
    viewBox="0 0 10 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.251892 0.207644C0.56745 -0.0796885 1.0612 -0.0677898 1.36128 0.236941L9.59866 8.60519L9.84085 8.85031L9.59866 9.09543L1.36128 17.4637C1.06124 17.7682 0.567387 17.7801 0.251892 17.493C-0.0713073 17.1983 -0.0857114 16.6999 0.221618 16.3875L7.64161 8.85031L0.221618 1.31312C-0.0858528 1.00081 -0.0711835 0.502416 0.251892 0.207644ZM0.381776 16.7654C0.380696 16.768 0.379873 16.7707 0.378847 16.7732C0.388742 16.7484 0.400992 16.7241 0.415956 16.701L0.381776 16.7654ZM0.575137 0.404911C0.565943 0.409925 0.556684 0.414833 0.547794 0.420536C0.556707 0.414886 0.565917 0.409869 0.575137 0.404911ZM0.635685 0.376591C0.628981 0.379005 0.622756 0.382626 0.616154 0.38538C0.627812 0.38057 0.639355 0.37551 0.65131 0.371708C0.646118 0.37338 0.640821 0.374735 0.635685 0.376591Z"
      fill="#F28741"
    />
  </svg>
);
